// components/BlogMenuSection.js
import React from 'react';
import './BlogMenuSection.css';
import backgroundImage from '../assets/6691.jpg';

const BlogMenuSection = ({
  title = "BLOG",
  subtitle1 = "",
  subtitle2 = "",
  subtitle3 = "",
  subtitle4 = "",
  categories = null,
  backgroundColor = "#f8f9fa",
  textColor = "#0a3764",
  accentColor = "#7d3f98",
  className = "",
  onCategoryClick,
  selectedCategory = "TOUS LES ARTICLES"
}) => {

  const getSubtitleClass = (categoryName) => {
    return `menu-subtitle ${categoryName === selectedCategory ? 'active' : ''}`;
  };

  const shouldDisplaySubtitle = (subtitle) => {
    return subtitle && subtitle.trim() !== "" && subtitle !== "DISABLED";
  };

  const getDisplayCategories = () => {
    if (categories && Array.isArray(categories) && categories.length > 0) {
      return categories;
    }

    const subtitles = [];
    if (shouldDisplaySubtitle(subtitle1)) subtitles.push({ displayName: subtitle1, nombre_articles: null });
    if (shouldDisplaySubtitle(subtitle2)) subtitles.push({ displayName: subtitle2, nombre_articles: null });
    if (shouldDisplaySubtitle(subtitle3)) subtitles.push({ displayName: subtitle3, nombre_articles: null });
    if (shouldDisplaySubtitle(subtitle4)) subtitles.push({ displayName: subtitle4, nombre_articles: null });

    return subtitles;
  };

  const displayCategories = getDisplayCategories();

  // Fonction pour obtenir l'affichage avec le nombre d'articles
  const getDisplayText = (category) => {
    const displayName = typeof category === 'object' ? category.displayName : category;
    const count = typeof category === 'object' ? category.nombre_articles : null;
    
    if (count !== null && count !== undefined && count > 0) {
      return `${displayName} (${count})`;
    }
    return displayName;
  };

  // Fonction pour obtenir le nom de la catégorie pour le clic
  const getCategoryName = (category) => {
    return typeof category === 'object' ? category.name || category.displayName : category;
  };

  return (
    <section
      className={`menu-section1 ${className}`}
      style={{
        backgroundColor,
        color: textColor,
        justifyContent: "space-between"
      }}
    >
      <div>
        <img
          src={backgroundImage}
          alt="Background"
          className="entreprise-page-hero-bg"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <div className="pourquoi-page-hero-overlay"></div>
        <div className="menu-espace">
          <h2 className="menu-section1-title" style={{ color: textColor }}>
            {title}
          </h2>

          <div className="menu-section1-subtitles-container">
            {displayCategories.map((category, index) => {
              const categoryName = getCategoryName(category);
              const displayText = getDisplayText(category);
              
              return (
                <span
                  key={index}
                  className={getSubtitleClass(categoryName)}
                  style={{ color: textColor, cursor: "pointer" }}
                  onClick={() => onCategoryClick && onCategoryClick(categoryName)}
                >
                  {displayText}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogMenuSection;